import React from 'react';

//Components
import {Switch, Route} from "react-router-dom";

//Routes
import Index from "../Index/Index";
import Notification from "../Notification/Notification";

import { ROUTER_PATH } from '../../../const/ROUTER_PATH';

const Notifications = () => (
    <Switch>
        <Route
            path={ROUTER_PATH.NOTIFICATIONS}
            exact
            component={Index}
        />
        <Route
            path={ROUTER_PATH.NOTIFICATIONS_PROMOTION_ID}
            component={Notification}
        />
    </Switch>
);

export default Notifications
